module.exports = __webpack_public_path__ + "img/typeall.8d68eabd.png";